function elMaybe(selector,content,appendTo){
	const 	exists = document.querySelector(selector),
			container = document.querySelector(appendTo);
	let 	newEl = undefined;

	if(exists){
		return exists;
	}
	else {
		newEl = content();
	}

	if(container){
		container.appendChild(newEl);
	}

	return newEl;
}

export default elMaybe;